import * as React from "react";

export default function PinIcon(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={15} height={17} viewBox="0 0 15 17" {...props}>
      <g transform="translate(1 -1)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={1.5} transform="translate(0 2)">
          <path d="M13 6.466C13 10.603 6.5 15 6.5 15S0 10.603 0 6.466C0 2.845 3.054 0 6.5 0S13 2.845 13 6.466z" />
          <circle cx={6.5} cy={6.5} r={2.5} />
        </g>
      </g>
    </svg>
  );
}
